import { SvgIcon } from '@mui/material';

export const DashboardIcon = props => {
  return (
    <SvgIcon {...props}>
      <g
        id="Group_82"
        data-name="Group 82"
        transform="translate(676.898 -52.102)"
      >
        <g id="dashboard" transform="translate(-676.898 52.102)">
          <path
            id="Path_41"
            data-name="Path 41"
            d="M31.759,8H8.389A.389.389,0,0,0,8,8.389V22.411a.389.389,0,0,0,.389.389h8.379a3.494,3.494,0,0,0,1.115,1.568.386.386,0,0,0,.123.066l-.2.79-3.248,1.082a1.95,1.95,0,0,0-1.881,1.924l-.349,3.139H10.337a.389.389,0,0,0,0,.779H29.812a.389.389,0,0,0,0-.779H27.823l-.349-3.139a1.95,1.95,0,0,0-1.881-1.924l-3.248-1.082-.2-.79a.386.386,0,0,0,.123-.066A3.494,3.494,0,0,0,23.381,22.8h8.379a.39.39,0,0,0,.389-.389V8.389A.39.39,0,0,0,31.759,8ZM25.4,27.065a.393.393,0,0,0,.123.02A1.17,1.17,0,0,1,26.7,28.254a.421.421,0,0,0,0,.043l.341,3.073H24.748V29.422a.389.389,0,0,0-.779,0V31.37h-7.79V29.422a.389.389,0,0,0-.779,0V31.37H13.109l.341-3.073a.421.421,0,0,0,0-.043,1.17,1.17,0,0,1,1.168-1.168.393.393,0,0,0,.123-.02l3.446-1.149h3.768Zm-2.6-5.433a2.715,2.715,0,0,1-.946,2.064.389.389,0,0,0-.6.417l.264,1.024h-2.89l.264-1.024a.389.389,0,0,0-.6-.417,2.715,2.715,0,0,1-.946-2.064V20.074a2.726,2.726,0,1,1,5.453,0Zm8.569.39H23.558a3.566,3.566,0,0,0,.021-.39V20.074a3.505,3.505,0,1,0-7.011,0v1.558a3.563,3.563,0,0,0,.021.389H8.779V8.779H31.37Z"
            transform="translate(-8 -8)"
          />
          <path
            id="Path_42"
            data-name="Path 42"
            d="M88.389,40.779h8.179a.389.389,0,1,0,0-.779H88.389a.389.389,0,1,0,0,.779Z"
            transform="translate(-84.105 -38.442)"
          />
          <path
            id="Path_43"
            data-name="Path 43"
            d="M88.389,64.779H95.4a.389.389,0,1,0,0-.779H88.389a.389.389,0,1,0,0,.779Z"
            transform="translate(-84.105 -61.274)"
          />
          <path
            id="Path_44"
            data-name="Path 44"
            d="M88.389,88.779h3.895a.389.389,0,0,0,0-.779H88.389a.389.389,0,0,0,0,.779Z"
            transform="translate(-84.105 -84.105)"
          />
          <path
            id="Path_45"
            data-name="Path 45"
            d="M40.39,43.116h1.168a.39.39,0,0,0,.39-.389V40.39a.39.39,0,0,0-.39-.39H40.39a.389.389,0,0,0-.39.39v2.337A.389.389,0,0,0,40.39,43.116Zm.389-2.337h.389v1.558h-.389Z"
            transform="translate(-38.442 -38.442)"
          />
          <path
            id="Path_46"
            data-name="Path 46"
            d="M331.505,40a3.505,3.505,0,1,0,3.506,3.505A3.505,3.505,0,0,0,331.505,40Zm.389.807a2.732,2.732,0,0,1,2.309,2.309h-2.309Zm-3.116,2.7a2.731,2.731,0,0,1,2.337-2.7v2.537l-1.793,1.793A2.712,2.712,0,0,1,328.779,43.506Zm2.727,2.726a2.712,2.712,0,0,1-1.632-.544l1.793-1.793H334.2A2.731,2.731,0,0,1,331.505,46.232Z"
            transform="translate(-312.42 -38.442)"
          />
          <path
            id="Path_47"
            data-name="Path 47"
            d="M372.284,200H368.39a.389.389,0,1,0,0,.779h3.895a.389.389,0,0,0,0-.779Z"
            transform="translate(-350.473 -190.652)"
          />
          <path
            id="Path_48"
            data-name="Path 48"
            d="M345.647,224h-3.895a.389.389,0,0,0-.275.114l-1.363,1.363a.39.39,0,0,0,.551.551l1.249-1.249h3.734a.389.389,0,0,0,0-.779Z"
            transform="translate(-323.835 -213.483)"
          />
          <path
            id="Path_49"
            data-name="Path 49"
            d="M39.011,124.284v-3.505a.389.389,0,0,0-.389-.389H37.453a.39.39,0,0,0-.389.389v3.505h-.389v-2.337a.389.389,0,0,0-.389-.389H35.116a.389.389,0,0,0-.389.389v2.337h-.389v-3.895a.389.389,0,0,0-.389-.389H32.779a.389.389,0,0,0-.389.389v3.895a.389.389,0,1,0,0,.779h6.621a.389.389,0,1,0,0-.779Zm-5.453,0h-.389v-3.505h.389Zm2.337,0h-.389v-1.947h.389Zm2.337,0h-.39v-3.116h.39Z"
            transform="translate(-30.832 -114.547)"
          />
          <path
            id="Path_50"
            data-name="Path 50"
            d="M32.389,232.779h4.123l1.639,1.639a.389.389,0,1,0,.551-.551l-1.753-1.753a.39.39,0,0,0-.275-.114H32.389a.389.389,0,0,0,0,.779Z"
            transform="translate(-30.832 -221.094)"
          />
          <path
            id="Path_51"
            data-name="Path 51"
            d="M32.389,256.779h1.558a.389.389,0,1,0,0-.779H32.389a.389.389,0,1,0,0,.779Z"
            transform="translate(-30.832 -243.926)"
          />
        </g>
      </g>
    </SvgIcon>
  );
};
